import React from "react";
import * as Icons from "lucide-react";
import { useContent } from "../contexts/ContentContext";

export default function Industries({ onEnquire }) {
  const { content } = useContent();
  const { industries } = content;

  if (!industries || industries.length === 0) return null;

  return (
    <section id="industries" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-block px-3 py-1 rounded-full bg-orange-50 text-orange-600 text-xs font-semibold tracking-wider mb-4">
            SECTORS WE POWER
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900">
            Industries <span className="text-orange-500">We Serve</span>
          </h2>
          <p className="text-slate-600 mt-4">
            Trusted by hospitals, schools, factories, telecom, defence, agriculture, and government
            projects across India.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-6 gap-3 lg:gap-4">
          {industries.map((it, i) => {
            const Icon = Icons[it.icon] || Icons.Building2;
            return (
              <div
                key={`${it.name}-${i}`}
                className="group flex flex-col items-center justify-center text-center px-3 py-5 rounded-xl border border-slate-200 bg-slate-50/40 hover:bg-white hover:border-[#0a4f47] hover:shadow-md transition-all cursor-default"
              >
                <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center group-hover:bg-[#0a4f47] transition-colors">
                  <Icon className="w-5 h-5 text-[#0a4f47] group-hover:text-orange-300 transition-colors" />
                </div>
                <div className="mt-3 text-xs font-semibold text-slate-700 leading-tight group-hover:text-[#0a4f47] transition-colors">
                  {it.name}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <button
            onClick={onEnquire}
            className="inline-flex items-center gap-2 px-6 h-11 rounded-md bg-[#0a4f47] hover:bg-[#0e6e63] text-white font-semibold transition-colors"
          >
            Discuss Your Industry <Icons.ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
